const roundUp = (num, decimal = 2) => {
  const numFloat = parseFloat(num);
  let thousandthDecimal = false;
  const numText = numFloat.toString();
  const splitPoint = numText.indexOf('.');

  // round up if we have a number in the thousandth position and the number is not 0
  if (splitPoint !== -1) {
    thousandthDecimal = !!numText[splitPoint + 3];
    if (Number(numText[splitPoint + 3]) === 0) thousandthDecimal = false;
  }
  const func = thousandthDecimal ? 'ceil' : 'round';
  return Math[func](numFloat * (10 ** decimal)) / (10 ** decimal);
};

export const formatCurrency = (number = 0) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
}).format(Math.abs(number));

export const totalQty = (tireDetails = []) => tireDetails
  .reduce((total, tire) => total + tire.qty, 0);

export const totalPrice = (tireDetails = [], installPrice = 0) => {
  const totalTirePrice = tireDetails
    .reduce((total, tire) => total + (tire.price * tire.qty), 0);
  const totalInstallPrice = installPrice * totalQty(tireDetails);

  return totalTirePrice + totalInstallPrice;
};

export const monthlyPayment = (price = 0, months = 1) => roundUp(price / months, 2);

export const numberOfTires = {
  1: 'one tire',
  2: 'two tires',
  3: 'three tires',
  4: 'four tires',
  5: 'five tires',
  6: 'six tires',
  7: 'seven tires',
  8: 'eight tires',
};

// users are eligible for financing if they buy 4 or more tires, or if their
// total purchase price is greater than $199
export const shouldShowFinancing = (price/* , qty */) => {
  if (price >= 199) {
    return true;
  }

  return false;
};

export const financingMonths = (price/* , qty */) => {
  // users get financing for 12 months if their purchase is $750 or more
  // if (price >= 750) {
  //   return 12;
  // }

  // users get financing for 6 months if their purchase is between $199 and $749.99
  // or if they purchase 4 or more tires (but don't reach the $199 threshold)
  // *******
  // UPDATE [July 11th 2023]:
  // Financing rules have changes. No longer offer 12 month financing.
  // No longer is there a 4 tire purchase requirement.
  // So long as the purchase is >= 199, financing become available.
  if (price >= 199) {
    return 6;
  }

  // ineligible users don't get financing at all, return 1 to avoid potential
  // divide-by-zero issues
  return 1;
};
